import { render, staticRenderFns } from "./PanelLegend.vue?vue&type=template&id=789916c5&"
import script from "./PanelLegend.vue?vue&type=script&lang=js&"
export * from "./PanelLegend.vue?vue&type=script&lang=js&"
import style0 from "./PanelLegend.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PanelLegend.vue"
export default component.exports